export default "__VITE_ASSET__JjqknKRI__"